<template>
  <div class="account-menu">
    <a
      v-if="!isLoggedIn && !isSignInDisabled"
      @click="handleMenuClick"
      class="sign-in"
    >
      <user-icon />
      <span>Sign In</span>
    </a>

    <a v-if="isLoggedIn" @click="handleMenuClick" class="account-control">
      <account-icon />
      <span>{{ user.name }}</span>
      <chevron-up />
    </a>

    <account-dropdown
      v-on-clickaway="hideDropdown"
      v-if="isAccountDropdown"
      @hide="hideDropdown"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { mixin as clickaway } from 'vue-clickaway'
import accountDropdown from 'components/user-menu/account-dropdown.vue'
import accountIcon from 'assets/images/icons/account-circle.svg?inline'
import chevronUp from 'assets/images/icons/chevron-up.svg?inline'
import UserIcon from 'assets/images/icons/user-menu.svg?inline'
import featureToggles from 'src/settings/feature-toggles'

export default {
  name: 'account-menu',
  components: {
    accountDropdown,
    accountIcon,
    chevronUp,
    UserIcon,
  },
  mixins: [clickaway],
  data() {
    return {
      isAccountDropdown: false,
    }
  },
  computed: {
    ...mapState({
      user: state => state.user.currentUser,
    }),
    isLoggedIn() {
      return this.$store.getters.isLoggedIn
    },
    isSignInDisabled() {
      return featureToggles.disableSignIn
    },
  },
  methods: {
    ...mapActions({
      showModal: 'showModal',
    }),
    handleMenuClick() {
      if (!this.isLoggedIn) {
        if (this.isSignInDisabled) {
          return
        }
        this.showModal('login')
      } else {
        this.isAccountDropdown = true
      }
    },
    hideDropdown() {
      this.isAccountDropdown = false
    },
  },
}
</script>

<style lang="scss" scoped>
.account-menu {
  display: inline-flex;
  position: relative;
  a {
    cursor: pointer;
  }
}
.menu-btn {
  min-width: 110px;
  padding: $padding-xs;
}
.account-control {
  display: inline-flex;
  align-items: center;
  color: $header-link-color;
  span {
    color: #002560;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    text-transform: uppercase;
    margin-right: $margin-s;
  }
  svg {
    margin-right: $margin-s;
  }
}
.sign-in {
  display: inline-flex;
  align-items: center;
  color: #002560;
  font-size: $header-size-5;
  text-transform: uppercase;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: $margin-xs;
  span {
    padding-top: 2px;
    margin-left: $margin-xs;
  }
}
</style>
